import { Controller } from '@hotwired/stimulus';
import { useMatchMedia } from 'stimulus-use';
import { useClickOutside } from 'stimulus-use';

export default class extends Controller {
  static targets = ['content', 'trigger'];

  initialize() {}

  connect() {
    useMatchMedia(this, {
      mediaQueries: {
        sm: '(min-width: 768px)',
      },
    });
    this.isTabletLayout = window.matchMedia('(min-width: 768px)').matches;

    const filterDrawer = this.element.closest('[data-filter-drawer-target="content"]');
    useClickOutside(this, { element: filterDrawer });
  }

  smChanged({ name, media, matches, event }) {
    this.isTabletLayout = matches;
    this.closeAll();
  }

  toggle() {
    // If Tablet Close all others
    if (this.isTabletLayout) {
      this.closeAll(this.element);
    }
    this.contentTarget.classList.toggle('hidden');
    this.triggerTarget.classList.toggle('active');
    const icon = this.triggerTarget.querySelector('svg');
    if (icon) {
      icon.classList.toggle('rotate-180');
    }
  }

  close(el) {
    const trigger = el.querySelector('[data-fieldgroup-modal-target="trigger"]');
    if (trigger) {
      trigger.classList.remove('active');
    }
    const content = el.querySelector('[data-fieldgroup-modal-target="content"]');
    if (content) {
      content.classList.add('hidden');
    }
    const icon = el.querySelector('svg');
    if (icon) {
      icon.classList.add('rotate-180');
    }
  }

  closeAll(excludeElement = null) {
    let allControllerElements = document.querySelectorAll('[data-controller="fieldgroup-modal"]');
    if (excludeElement) {
      allControllerElements = [...allControllerElements].filter((el) => el !== excludeElement);
    }
    Array.from(allControllerElements).forEach((element) => {
      this.close(element);
    });
  }

  clickOutside(event) {
    this.closeAll();
  }
}
